import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_HAS_QR_CODE_LINK_CUSTOMIZE_STEP_VISITED = 'UPDATE_HAS_QR_CODE_LINK_CUSTOMIZE_STEP_VISITED' as const;

export const updateHasQrCodeLinkCustomizeStepVisited = (visited: boolean) => ({
  data: { visited },
  type: UPDATE_HAS_QR_CODE_LINK_CUSTOMIZE_STEP_VISITED,
});

export type UpdateHasQrCodeLinkCustomizeStepVisitedResponseAction = DataAction<
  typeof UPDATE_HAS_QR_CODE_LINK_CUSTOMIZE_STEP_VISITED,
  { visited: boolean }
>;
